import React, { useEffect, useState } from "react"

import styles from './header.module.css';
import { Link, NavLink } from "react-router-dom";
import MobileMenu from './mobile_menu';

const Header = (props) => {
    const [scrollPosition, setScrollPosition] = useState(0);
    useEffect(() => {
        const updateScroll = () => {
            const position = window.scrollY || document.documentElement.scrollTop;
            setScrollPosition(position);
        }
        updateScroll();
        window.addEventListener('scroll', updateScroll);
        return () => window.removeEventListener('scroll', updateScroll);
    }, []);

    // const onRecruitClick = () => {
    //     props.onRecruitClick()
    // }

    const onLogoClick = () => {
        props.onLogoClick?.()
    }

    let headerStyle = scrollPosition < 10 && !props.linkFlag ? styles.header : styles.change_header

    return (
        <header className={headerStyle}>
            <div className={styles.container}>
                <Link to="/"><h1 onClick={onLogoClick}>JSOFTWARE</h1></Link>
                <ul id="gnb" aria-label="주 메뉴">
                    <li><NavLink to="/company">회사소개</NavLink></li>
                    <li><NavLink to="/portfolio">사업영역</NavLink></li>
                    <li><NavLink to="/services">서비스</NavLink></li>
                    <li><NavLink to="/education">교육·강의</NavLink></li>
                </ul>

                <MobileMenu visible={scrollPosition >= 10 || !!props.linkFlag} />
            </div>
            {/* <Outlet /> */}
        </header>
    )
}

export default React.memo(Header);